"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _unshift = _interopRequireDefault(require("unmutable/lib/unshift"));

var Action = function Action() {
  var _this = this;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _type = _ref.type,
      _payload = _ref.payload,
      _keyPath = _ref.keyPath,
      _steps = _ref.steps;

  (0, _classCallCheck2.default)(this, Action);
  (0, _defineProperty2.default)(this, "type", "");
  (0, _defineProperty2.default)(this, "payload", {});
  (0, _defineProperty2.default)(this, "keyPath", []);
  (0, _defineProperty2.default)(this, "steps", []);
  (0, _defineProperty2.default)(this, "_create", function (create) {
    return new Action((0, _objectSpread2.default)({}, _this.toJS(), create));
  });
  (0, _defineProperty2.default)(this, "_addStep", function (step) {
    return _this._create({
      steps: (0, _unshift.default)(step)(_this.steps),
      keyPath: step.type === 'get' ? (0, _unshift.default)(step.key)(_this.keyPath) : _this.keyPath
    });
  });
  (0, _defineProperty2.default)(this, "toJS", function () {
    var type = _this.type,
        payload = _this.payload,
        keyPath = _this.keyPath,
        steps = _this.steps;
    return {
      type: type,
      payload: payload,
      keyPath: keyPath,
      steps: steps
    };
  });
  this.type = _type || this.type;
  this.payload = _payload || this.payload;
  this.keyPath = _keyPath || this.keyPath;

  if (!_steps) {
    _steps = _keyPath ? _keyPath.map(function (key) {
      return {
        type: 'get',
        key: key
      };
    }) : this.steps;
  }

  this.steps = _steps;
};

exports.default = Action;